const Tab = (props) => {
    return <div></div>;
};

export default Tab;
